/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

const buttonSizeVariants = {
    small: {
        height: 31,
        fontSize: 10,
        padding: "0 16px",
        icon: 13,
        iconPadding: 5,
        lineHeight: 11,
    },
    medium: {
        height: 33,
        fontSize: 12,
        padding: "0 24px",
        icon: 15,
        iconPadding: 7,
        lineHeight: 13,
    },
    large: {
        height: 43,
        fontSize: 16,
        padding: "0 20px",
        icon: 20,
        iconPadding: 9,
        lineHeight: 17,
    },
};

export default buttonSizeVariants;
